export default __webpack_public_path__ + "static/media/lib-2.9ca4580f.webp";